import { render, staticRenderFns } from "./NewStripe.vue?vue&type=template&id=3f47f770&"
import script from "./NewStripe.vue?vue&type=script&lang=js&"
export * from "./NewStripe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports